import { __exports as object } from "./index217.js";
var hasRequiredObject;
function requireObject() {
  if (hasRequiredObject) return object;
  hasRequiredObject = 1;
  Object.defineProperty(object, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var ObjectRenderer = (function() {
    function ObjectRenderer2(object2, encodings, options) {
      _classCallCheck(this, ObjectRenderer2);
      this.object = object2;
      this.encodings = encodings;
      this.options = options;
    }
    _createClass(ObjectRenderer2, [{
      key: "render",
      value: function render() {
        this.object.encodings = this.encodings;
      }
    }]);
    return ObjectRenderer2;
  })();
  object.default = ObjectRenderer;
  return object;
}
export {
  requireObject as __require
};
//# sourceMappingURL=index187.js.map
